<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Schedule</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Nama</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.name"
                class="form-input"
                placeholder="Masukkan Nama"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Batch</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.batch_number"
                @input="
                  () => {
                    if (form.batch_number < 0) {
                      form.batch_number = 1;
                    }
                  }
                "
                class="form-input"
                placeholder="Batch"
                type="number"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Total Sesi</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.session"
                @input="
                  () => {
                    if (form.session < 0) {
                      form.session = 0;
                    }
                  }
                "
                class="form-input"
                placeholder="Total Sesi"
                type="number"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Batas Peserta</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.total_audience"
                @input="
                  () => {
                    if (form.total_audience < 0) {
                      form.total_audience = 1;
                    }
                  }
                "
                class="form-input"
                placeholder="Batas Peserta"
                type="number"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Durasi</p>
              <v-row no-gutters class="pt-2">
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="3" class="pt-2"> Mulai </v-col>
                    <v-col cols="8">
                      <v-text-field
                        :disabled="isWatch"
                        outlined
                        type="datetime-local"
                        v-model="form.start_date"
                        class="form-input"
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="4" class="pt-2"> Selesai </v-col>
                    <v-col cols="8">
                      <v-text-field
                        :disabled="isWatch"
                        outlined
                        type="datetime-local"
                        v-model="form.end_date"
                        class="form-input"
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="content-form">
              <p>Deskripsi</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Tulis deskripsi ..."
                outlined
                rows="3"
                v-model="form.description"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Alamat Lokasi (Tipe Offline)</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.location_address"
                class="form-input"
                placeholder="Masukkan Alamat"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Link GMaps (Tipe Offline)</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.location_map"
                class="form-input"
                placeholder="Masukkan Link GMaps"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Catatan Tambahan</p>
              <vue-editor
                v-model="form.notes"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                :disabled="isWatch"
              ></vue-editor>
            </div>
            <div class="content-form">
              <p>Kelas Kategori</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="class_categories"
                v-model="form.category_id"
                solo
                :item-text="'name'"
                :item-value="'id'"
                placeholder="Pilih Kelas Kategori"
                @change="getClass"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Kelas</p>
              <v-select
                :disabled="isWatch || !form.category_id"
                class="form-input"
                :items="classes"
                v-model="form.class_id"
                solo
                :item-text="'name'"
                :item-value="'id'"
                placeholder="Pilih Kelas"
              ></v-select>
            </div>
            <div class="content-form">
              <p class="mb-5">Dynamic Sesi</p>
              <div v-for="(item, idx) in form.session_schedule" :key="idx">
                <div class="session-numb">
                  <p style="font-weight: bold">Sesi {{ idx + 1 }}</p>
                  <div
                    @click="form.session_schedule.splice(idx, 1)"
                    style="cursor: pointer"
                    v-if="!isWatch && form.session_schedule.length > 1"
                  >
                    <Strip />
                  </div>
                </div>
                <div class="content-form">
                  <p>Hari & Tanggal Pelaksanaan</p>
                  <v-text-field
                    :disabled="isWatch"
                    outlined
                    type="date"
                    :rules="[!!item.date_start || 'Wajib diisi!']"
                    v-model="item.date_start"
                    class="form-input"
                    dense
                  ></v-text-field>
                </div>
                <div class="content-form">
                  <p>Jam Pelaksanaan</p>
                  <div class="container-date pt-2">
                    <div class="container-date-left">
                      <v-row no-gutters>
                        <v-col cols="3" class="pt-2"> Mulai </v-col>
                        <v-col cols="8">
                          <v-text-field
                            :disabled="isWatch"
                            outlined
                            type="time"
                            :rules="[!!item.start_time || 'Wajib diisi!']"
                            v-model="item.start_time"
                            class="form-input"
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="container-date-right">
                      <v-row no-gutters>
                        <v-col cols="3" class="pt-2"> Selesai </v-col>
                        <v-col cols="8">
                          <v-text-field
                            :disabled="isWatch"
                            outlined
                            type="time"
                            :rules="[!!item.end_time || 'Wajib diisi!']"
                            v-model="item.end_time"
                            class="form-input"
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-button" @click="addSessionSchedule" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Jadwal Per Sesi</div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Name</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.name"
                class="form-input"
                placeholder="Enter Name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Description</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Write description ..."
                outlined
                rows="3"
                v-model="formEng.description"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Additional Notes</p>
              <vue-editor
                v-model="formEng.notes"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                :disabled="isWatch"
              ></vue-editor>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/schedule')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "@/components/ilustration/Loading.vue";
import Button from "@/components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from "@/components/icons/Arrow.vue";
import Strip from "@/components/icons/Strip.vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "FormSchedule",
  components: {
    Loading,
    Button,
    Popup,
    Arrow,
    Strip,
    VueEditor,
  },
  computed: {
    validData() {
      return (
        this.form.name &&
        this.form.batch_number &&
        this.form.session &&
        this.form.total_audience &&
        this.form.start_date &&
        this.form.end_date &&
        this.form.category_id &&
        this.form.class_id &&
        this.form.session_schedule.every(
          (session) => session.date_start && session.start_time && session.end_time
        )
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      classes: [],
      class_categories: [],
      form: {
        name: "",
        batch_number: 1,
        session: 0,
        total_audience: 1,
        start_date: "",
        end_date: "",
        description: "",
        location_address: "",
        location_map: "",
        notes: "",
        category_id: 0,
        class_id: 0,
        is_active: true,
        session_schedule: [
          { date_start: "", date_end: "", start_time: "", end_time: "" },
        ],
      },
      formEng: {
        name: "",
        description: "",
        notes: "",
      },
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getSchedule();
    },
    async getSchedule() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/schedule/" + this.id);
        const data = resp.data.data.schedule;
        this.form = {
          ...data,
          start_date: moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss"),
          end_date: moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss"),
          session_schedule: data.session_schedule || [
            { date_start: "", date_end: "", start_time: "", end_time: "" },
          ],
        };
        await this.getBilingual();
        await this.getClass();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=schedule&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          name: resp.name || "",
          description: resp.description || "",
          notes: resp.notes || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async getClass() {
      try {
        const resp = await this.$crm_http.get(
          `/v1/class/category/${this.form.category_id}?page=0&per_page=100`
        );
        this.classes = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getClassCategory() {
      try {
        const resp = await this.$crm_http.get("/v1/class-category");
        this.class_categories = resp.data.data.class_categories;
      } catch (err) {
        console.log(err);
      }
    },
    addSessionSchedule() {
      this.form.session_schedule.push({
        date_start: "",
        date_end: "",
        start_time: "",
        end_time: "",
      });
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        const payload = {
          name: this.form.name,
          batch_number: Number(this.form.batch_number),
          session: Number(this.form.session),
          total_audience: Number(this.form.total_audience),
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          description: this.form.description,
          location_address: this.form.location_address,
          location_map: this.form.location_map,
          notes: this.form.notes,
          category_id: Number(this.form.category_id),
          class_id: Number(this.form.class_id),
          is_active: this.form.is_active,
          session_schedule: this.form.session_schedule,
          days:
            moment(this.form.start_date).format("DD-MM-YYYY") +
            " - " +
            moment(this.form.end_date).format("DD-MM-YYYY"),
          hours:
            moment(this.form.start_date).format("HH:mm") +
            " - " +
            moment(this.form.end_date).format("HH:mm"),
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/schedule/" + this.id, payload);
          await this.onSubmitBilingual();
        } else {
          await this.$crm_http.post("/v1/schedule", payload);
        }

        setTimeout(() => {
          this.$router.push("/schedule");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual() {
      const payload = {
        table_name: "schedule",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          name: this.formEng.name,
          description: this.formEng.description,
          notes: this.formEng.notes,
          batch_number: Number(this.form.batch_number),
          session: Number(this.form.session),
          total_audience: Number(this.form.total_audience),
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          location_address: this.form.location_address,
          location_map: this.form.location_map,
          category_id: Number(this.form.category_id),
          class_id: Number(this.form.class_id),
          is_active: this.form.is_active,
          session_schedule: this.form.session_schedule,
          days:
            moment(this.form.start_date).format("DD-MM-YYYY") +
            " - " +
            moment(this.form.end_date).format("DD-MM-YYYY"),
          hours:
            moment(this.form.start_date).format("HH:mm") +
            " - " +
            moment(this.form.end_date).format("HH:mm"),
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
    this.getClassCategory();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
.add-button {
  margin: 15px 0;
  display: flex;
  align-items: center;
  gap: 20px;
}
.add-button .line {
  width: 40%;
  background-color: #d3d6e1;
  height: 2px;
}
.add-button .button {
  min-width: max-content;
  padding: 7px 20px;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid #d3d6e1;
}
.session-numb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.container-date {
  display: flex;
  gap: 15px;
}
.container-date-left {
  width: 50%;
}
.container-date-right {
  width: 50%;
}
</style>